import React from 'react';
import { prop, propOr } from 'ramda';
import classNames from 'classnames';
import { Button } from 'antd';
import LinkButton from './LinkButton';

const Actions = ({
  actions = [],
  buttons,
  title,
  listEmpty,
  alignButtonEndRight = false,
  icon
}) => (
  <div className={classNames('flex justify-end w-full items-end pt-2', { 'justify-between': title }, { 'items-baseline': listEmpty })}>
    {title}
    <div className={classNames({ 'inline-flex items-center space-x-4': alignButtonEndRight })}>
      {actions.map((action, index) => (
        <div key={index} className={classNames({ 'pt-4': listEmpty })}>
          {prop('to', action) ? (
            <LinkButton
              to={prop('to', action)}
              type="primary"
              size="large"
              disabled={propOr(false, 'disabled', action)}
              icon={icon}
            >
              {prop('label', action)}
            </LinkButton>
          ) : (
            <Button
              loading={prop('loading', action)}
              disabled={prop('disabled', action)}
              onClick={prop('onClick', action)}
              size="large"
              type="primary"
              icon={prop('icon', action)}
              className={prop('className', action)}
            >
              {prop('label', action)}
            </Button>
          )}
        </div>
      ))}
      {buttons && (
        <div className="flex items-center gap-4">
          {buttons}
        </div>
      )}
    </div>
  </div>
);

export default Actions;
